import { useDispatch, useSelector } from "react-redux";
import { clearNotice, undoNotice } from "../../actions/noticeActions";

/** Transient toast at the bottom of the screen: a confirmation with an optional undo, or why something did not go through. */
const Notice = () => {
  const dispatch = useDispatch();
  const { message, kind, sub, canUndo } = useSelector((state) => state.notice);

  if (!message) return null;

  return (
    <div className={`toast toast-${kind}`} role="status">
      <span className="toast-icon" aria-hidden="true">
        {kind === "error" ? "!" : "✓"}
      </span>
      <span className="grow">
        <span className="toast-text">{message}</span>
        {sub && <span className="toast-sub">{sub}</span>}
      </span>
      {canUndo && (
        <button type="button" className="toast-action" onClick={() => dispatch(undoNotice())}>
          Undo
        </button>
      )}
      <button type="button" className="toast-close" aria-label="Dismiss" onClick={() => dispatch(clearNotice())}>
        ×
      </button>
    </div>
  );
};

export default Notice;
